module.exports = __webpack_public_path__ + "img/t2.ea07cd78.png";